import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');

export const getters = {
    getTypeActorFields() {
        return {
            model: 'type_actor',
            label: 'Types Actor',
            fields: [
                { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
                { key: 'id_license', label: 'id_license', type: 'number', sortable: true, required: true },
                { key: 'status', label: 'status', type: 'boolean', sortable: true, required: true },
            ]
        }
    },
}

export const actions = {
    async fetchLicenses(context, query = '') {
        return axios
            .get(`${serverUrl}/api/v1/licenses/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async fetchOptionsLicenses(context, query = '') {
        return axios
            .options(`${serverUrl}/api/v1/licenses/${query}`)
            .then((response) => {
                return response.data;
            })
    },

    async createLicenses(context, payload) {
        return axios
            .post(`${serverUrl}/api/v1/licenses/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async updateLicenses(context, payload) {
        return axios
            .put(`${serverUrl}/api/v1/licenses/${payload.id}/`, payload)
            .then((response) => {
                return response.data;
            })
    },

    async deleteLicenses(context, id) {
        return axios
            .delete(`${serverUrl}/api/v1/licenses/${id}/`)
            .then((response) => {
                return response.data;
            })
    }
}